<template>
  <tutorial-main @back="goBack">
    <template slot="nav">
      <div class="tutorialNav">
        <div class="tutorialType">
          <div :class="{btn: true, btnBg: req_data.is_excellent != 'Y'}"
               @click="switchTab('')">学员教案
          </div>
          <div :class="{btn: true, btnBg: req_data.is_excellent == 'Y'}"
               @click="switchTab('Y')">优秀教案
          </div>
        </div>
        <div class="filterWrap">
          <p>类型</p>
          <select v-model="req_data.session_type"
                  @change="filterTutorial">
            <option value="">全部教案</option>
            <option value="practice">实践教案</option>
            <option value="exam">考试教案</option>
          </select>
          <select v-model="req_data.user_id"
                  @change="filterTutorial">
            <option value="">全部学员</option>
            <option v-for="(item, index) in user_list"
                    :key="index"
                    :value="item.uid">{{item.user_name}}
            </option>
          </select>
          <div class="btn" v-if="classTrain.class_train_type === 'train' || classTrain.class_train_type === 'physical_train' || classTrain.class_train_type === 'goalkeeper_train'"
               @click="downloadTutorial()">下载考试教案
          </div>
        </div>
      </div>
    </template>
    <template slot="main">
      <div class="tutorialMain">
        <template v-if="showList">
          <div class="scrollArea">
            <vue-scroll :ops="ops">
              <div class="tutorialWrap"
                   v-if="showList">
                <div class="tutorialItem"
                     v-for="(item) in list"
                     :key="item.plan_id"
                     @click="lookOverDetail(item.plan_id)">
                  <div class="up">
                    <div class="imgWrap">
                      <img :src="item.drill_id | addSrc(item.last_updated)"
                           @error="imgTutorialErr($event)"
                           alt="">
                      <tutorial-type :excellent="item.is_excellent"
                                     :type="item.session_type"></tutorial-type>
                      <tutorial-excellent v-if="Number(item.is_excellent) === 1"></tutorial-excellent>
                    </div>
                    <div class="title">
                      <p>{{item.title}}</p>
                      <div class="author">作者：{{item.user_name}}</div>
                    </div>
                  </div>
                  <div class="down">
                    <!-- <div class="author">作者：{{item.user_name}}</div> -->
                    <!-- <div class="updateTime">更新：{{item.last_updated | time}}</div> -->
                    <div class="club_name">{{item.class_name}}</div>
                  </div>
                </div>
              </div>
            </vue-scroll>
          </div>
          <div id="paging">
            <yioks-paging :paging="paging" @goto-page="gotoPage($event)"></yioks-paging>
          </div>
        </template>
        <yioks-empty v-show="showEmpty"></yioks-empty>
        <el-dialog
            class="tutorial-downloading"
            :visible.sync="downloading"
            :close-on-click-modal="false"
            :show-close="false"
            width="35%">
          <div class="loading">
            <!--<yioks-loading :loadingText="'全部考试教案pdf生成中，请稍后...'"></yioks-loading>-->
            <el-progress type="circle"
                         :width="110"
                         :percentage="downloadPercent"></el-progress>
            <p>全部考试教案pdf生成中，请稍后...</p>
          </div>
          <div class="btn-wrap">
            <button class="btn"
                    @click="cancelDownload">取消生成
            </button>
          </div>
        </el-dialog>
        <a :href="pdf_url"
           ref="downloadA"
           download=""
           hidden="hidden">test</a>
      </div>
    </template>
  </tutorial-main>
</template>

<script>
  import ops from '@/assets/js/vuescrollOption';
  import Img from "@/assets/images/plan_default.png";
  import {stuTutorialList} from "@/api/common/api";
  import {downloadNum} from "@/api/training_teacher/api";
  import {storageData} from "@/assets/js/storage";
  import axios from 'axios';
  let CancelToken = axios.CancelToken;

  export default {
    name: "stus-tutorial",
    data() {
      const token = storageData.getToken();
      return {
        showList: false,
        showEmpty: false,
        ops: ops(),
        imgSrc: Img,
        page: 1,
        paging: {
          start: 0,
          prePage: 1, // 一页多少条数据
          total: 1, // 总页数
          size: 3, // 页码显示限制
          last: true, // 尾页
          next: true, // 下一页
          first: true, // 首页
          previous: true, // 上一页
          jump: true
        },
        c_id: this.$route.query.c_id,
        req_data: {
          c_id: this.$route.query.c_id,
          user_id: "",
          session_type: "",
          is_excellent: "",
        },
        list: [],
        user_list: [],
        count: {},
        classTrain:{},
        downloading: false,
        token,
        pdf_url: "",
        abort: null,
        pdfNum: 0,
        downloadPercent: 0,
      };
    },
    filters: {
      addSrc(src,lastUpdated) {
        return `/uploads/library/${src}.jpg?v=${lastUpdated}`;
      }
    },
    components: {
      "tutorial-main": () => import("@/components/LayOut/Common/up-down"),
      "yioks-paging": () => import("@/components/Pagination/Page"),
      "tutorial-type": () => import("@/components/Tutorial/tutorial-type"),
      "yioks-empty": () => import("@/components/Tips/Empty"),
      "tutorial-excellent": () => import("@/components/Tutorial/tutorial-excellent"),
      "yioks-loading": () => import("@/components/Loading/Loading"),
    },
    created() {
      this.setData();
      this.getDownloadNum();
      this.req_list();
    },
    methods: {
      setData() {
        const {type, tutorial, stu, page} = this.$route.query;
        type && (this.$set(this.req_data, "is_excellent", type));
        tutorial && (this.$set(this.req_data, "session_type", tutorial));
        stu && (this.$set(this.req_data, "user_id", stu));
        page && (this.page = page);
      },
      goBack() {
        this.$router.go(-1);
      },
      req_list() {
        stuTutorialList({"page": this.page, ...this.req_data})
          .then((res) => {
            // console.log(res);
            if (Number(res.data.status) === 0) {
              const {list, page, plan_count, user_list,classTrain} = res.data.result;
              this.list = list;
              this.count = plan_count;
              this.user_list = user_list;
              this.classTrain = classTrain;
              this.$set(this.paging, "prePage", page.page_size);
              this.$set(this.paging, "total", page.total_row);
              this.$set(this.paging, "start", (this.page - 1) * this.paging.prePage);
              this.showList = Boolean(list.length > 0);
              this.showEmpty = !this.showList;
            }
          })
          .catch((err) => {
            console.error(err);
          });
      },
      gotoPage(start) {
        this.page = parseInt(start / this.paging.prePage) + 1;
        this.changeQuery(false);
      },
      changeQuery(flag) {
        flag && (this.page = 1);
        this.$router.replace({
          path: this.$route.path,
          query: {
            ...this.$route.query,
            type: this.req_data.is_excellent,
            tutorial: this.req_data.session_type,
            stu: this.req_data.user_id,
            page: this.page,
          }
        });
        this.req_list();
      },
      switchTab(type) {
        this.$set(this.req_data, "is_excellent", type);
        this.filterTutorial();
      },
      filterTutorial() {
        this.changeQuery(true);
      },
      imgTutorialErr(e) {
        e.target.src = this.imgSrc;
      },
      lookOverDetail(id) {
        // console.log(id);
        this.$router.push({path: "tutorial_detail", query: {id: id}});
      },
      getDownloadNum() {
        downloadNum({ c_id: this.c_id })
          .then(({ data }) => {
            if(Number(data.status) === 0) {
              this.pdfNum = data.result.session_num;
            }
          })
          .catch((err) => {
            console.error(err);
          });
      },
      makeProgress() {
        this.downloadPercent = 0;
        const step = Math.floor(99 / (this.pdfNum));
        const timer = setInterval(() => {
          if(this.downloadPercent >= 99) {
            clearInterval(timer);
            return false;
          }
          if(this.downloadPercent + step >= 99) {
            this.downloadPercent = 99;
          } else {
            this.downloadPercent += step;
          }
        }, 1500);
      },
      downloadTutorial() {
        if(this.pdfNum <= 0) {
          this.$message({
            type: "error",
            message: "该培训班暂无考试教案，请稍后重试"
          });
          return false;
        }
        this.downloading = true;
        this.makeProgress();
        axios.get('/api/plan/pdf_download_batch', {
          headers: {
            "X-Token": this.token,
            "X-UserType":storageData.getUserType()
          },
          params: {
            c_id: this.c_id,
          },
          cancelToken: new CancelToken((cancel) => {
            this.abort = cancel;
          }),
        })
          .then(({data}) => {
            if (Number(data.status) === 0) {
              this.pdf_url = data.result.pdf_url;
              this.downloadPercent = 100;
              this.$nextTick(() => {
                this.$refs['downloadA'].click();
              });
              setTimeout(() => {
                this.downloading = false;
              }, 800);
            }else{
              this.downloading = false;
              this.$message.error(data.msg);
            }
          })
          .catch((err) => {
            this.downloading = false;
            console.error(err);
          });
      },
      cancelDownload() {
        this.abort("用户取消操作");
      },
    }
  }
</script>
<style lang="stylus">
  @import '~@/assets/css/variable';
  .tutorial-downloading {
    .el-dialog__header {
      padding: 0;
    }
    .loading {
      position: relative;
      height: 200px;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      align-items: center;
    }
    .btn-wrap {
      display: flex;
      justify-content: center;
      align-items: center;
      .btn {
        padding: 12px 20px;
        font-size: 14px;
        border-radius: 4px;
        color: $color_white;
        background-color: $color_err;
        border: none;
        outline: none;
        cursor: pointer;
      }
    }
  }
</style>
<style lang="stylus" scoped>
  @import '~@/assets/css/variable';
  @import '~@/assets/css/mixin';
  btn()
    padding 5px 15px
    margin 0 10px 0 0
    font-size $font_size_big
    cursor pointer
    user-select none
  .tutorialNav {
    padding: 0 12px;
    flex: 1 1 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .tutorialType {
      display: flex;
      .btn {
        btn();
      }
      .btnBg {
        background-color: $color_suc;
      }
    }
    .filterWrap {
      display: flex;
      p {
        align-self: center;
        font-size: $font_size_big;
      }
      select {
        width: 145px;
        height: 35px;
        padding: 0 0 0 10px;
        margin: 0 0 0 10px;
        color: $color_black;
        font-size: $font_size_medium;
      }
      .btn {
        btn();
        margin: 0 0 0 10px;
        background-color: $color_primary;
      }
    }
  }

  .tutorialMain {
    width: 100%;
    height: 100%;
    padding: 40px 0 0 0;
    background-color: $block_bg_color_base;
    .scrollArea {
      width: 100%;
      height: calc(100% - 77px);
      .tutorialWrap {
        padding: 0 35px 0 30px;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        .tutorialItem {
          flex: 0 0 auto;
          width: 405px;
          height: 170px;
          padding 15px 20px 0 20px
          margin: 0 0 30px 0;
          font-size: $font_size_big;
          background-color: $block_bg_color_base;
          cursor: pointer;
          .up {
            display: flex;
            padding: 0 0 15px 0;
            border-bottom: 1px solid $color_white;
            .imgWrap {
              flex: 0 0 auto;
              position: relative;
              width: 170px;
              height: 100px;
              img {
                width: 100%;
                height: 100%;
              }
            }
            .title {
              height: 100px;
              padding: 0 0 0 10px;
              overflow: hidden;
              .author {
                over_hide()
                line-height 1
              }
              p {
                display: -webkit-box;
                -webkit-line-clamp: 4;
                /* autoprefixer: off */
                -webkit-box-orient: vertical;
                overflow hidden
                height 75px
                margin-bottom 5px
              }
            }
          }
          .down {
            display: flex;
            justify-content: space-between;
            padding: 10px 0 0;
            font-size: 14px
            line-height 1
            .club_name {
              over_hide()
            }
          }
        }
      }
    }
    #paging {
      width: 100%;
      height: 77px;
    }
  }
</style>
